export default {
  data: function(){return{
    constants: {
      cssMask: '<style type="text/css">.ea-blur *, .ea-blur {color: transparent!important; text-shadow: 0 0 8px rgba(0,0,0,0.7);} .ea-hide *, .ea-hide {color: rgba(0,0,0,0);} .ea-mask *, .ea-mask {color: black;background-color: black;white-space:nowrap; -moz-transform: rotate(.8deg) skewx(-12deg);-moz-box-shadow:3px 0 2px #444; border:1px dotted #555; background: -moz-linear-gradient(180deg, #000, #222);}@media print {div, tr, td {page-break-inside: avoid!important;-webkit-region-break-inside: avoid!important;}}</style>',
      minWidth: '<script type="text/javascript">document.body.style.minWidth = "600px";<\/script>'
    },
    showResendDifferent: false,
    differentEmailAddress: null,
  }},  
  methods: {
    getEmailUrl(email){
      if (email){
        return '/api/v1/email/'+ encodeURIComponent(email.locator);
      } else {
        return '';
      }
    },
    downloadFile (downloadUrl, label) {
      fetch(downloadUrl,{credentials:'include'})
      .then(response => response.blob())
      .then(blob=>{
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = label
        link.click()
        URL.revokeObjectURL(link.href)
      })
      .catch((e) => {
        console.warn(e);
      })
    },
    prettifyCaption(text) {
      return text.substr(0,1).toUpperCase() + text.substr(1).replace(/\_/g," ");
    },
    setMasks(iframe,suppressMinWidth) {
      try {
        if ((this.selectedRecord) && this.selectedRecord.doc_type!='pdf') { 
          console.log($(iframe).contents().find("head"))
          $(iframe).contents().find("head").append(this.constants.cssMask);
          if(suppressMinWidth==undefined){
            $(iframe).contents().find("body").append(this.constants.minWidth);
          }
        } else {
          console.log(this.selectedRecord)
        }

      } catch(e) {
        console.warn(e);
      }
    },
    closePopovers: function()  {
      $('[data-toggle="popover"]').popover('hide');
    },
  
    iFrameReady(iFrame, fn) {
      var timer;
      var fired = false;

      function ready() {
          if (!fired) {
              fired = true;
              clearTimeout(timer);
              fn.call(this);
          }
      }

      function readyState() {
          if (this.readyState === "complete" || this.readyState === "interactive") {
              ready.call(this);
          }
      }

      // cross platform event handler for compatibility with older IE versions
      function addEvent(elem, event, fn) {
          if (elem.addEventListener) {
              return elem.addEventListener(event, fn);
          } else {
              return elem.attachEvent("on" + event, function () {
                  return fn.call(elem, window.event);
              });
          }
      }

      // use iFrame load as a backup - though the other events should occur first
      addEvent(iFrame, "load", function () {
          ready.call(iFrame.contentDocument || iFrame.contentWindow.document);
      });

      function checkLoaded() {
          var doc = iFrame.contentDocument || iFrame.contentWindow.document;
          console.log("readyState: " + doc.readyState + ",doc.URL" + doc.URL)
          // We can tell if there is a dummy document installed because the dummy document
          // will have an URL that starts with "about:".  The real document will not have that URL
          if (doc.URL.indexOf("about:") !== 0) {
              if (doc.readyState === "complete" || doc.readyState === "interactive") {
                ready.call(doc);
              } else {
                // set event listener for DOMContentLoaded on the new document
                addEvent(doc, "DOMContentLoaded", ready);
                /*addEvent(doc, "readystatechange", readyState);*/
              }
          } else {
              // still same old original document, so keep looking for content or new document
              timer = setTimeout(checkLoaded, 20);
          }
      }
      checkLoaded();
    },
    /**
     * This replaces iframeReady above, which doesn't work at all as intended.
     */
    async iframeReady2(iFrameId,fn){
      function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      if (this.selectedRecord.doc_type == "pdf"){
        //only relevant for html emails
        return;
      }
      let iFrame = $("#" + iFrameId);
      let origUuid = this.selectedRecord.uuid;
      iFrame.contents().find('body').html("");
      while(true){
        await sleep(100)
        if (origUuid != this.selectedRecord.uuid){
          //if selectedRecord changed, exit this because it's no longer relevant
          console.log("selectedRecord has changed, exiting iframeReady2")
          break;
        }
        let iframeHtml = iFrame.contents().find('body').html();
        //checks if iframe has html in it, if so, execute the callback and exit
        if (iframeHtml && iframeHtml.length > 0){
          fn()
          break;
        }
      }
    },

    loadPrintFrame(id,src,parentId) {

      if (parentId) {
        var parentNode = document.getElementById(parentId);
        var iframe = document.createElement("iframe");
        iframe.src = "";
        parentNode.replaceChild(iframe,document.getElementById(id));
        iframe.id = id;

      } else {
        var iframe = document.getElementById(id)
      }
      
      var printHeight = 935;
      var frameHeight = printHeight;
      var that = this;

      if ((this.privs.PE) || (this.privs.AO)) {

        if (src != iframe.src) {
          iframe.style.height = '200px';
          iframe.style.height = printHeight + 'px';
          iframe.style.width = '720px';
          iframe.src = src;

          var timer = null;
          var timerCount = 1;

          function formatPrintPane(){            
            
            if ((that.selectedRecord) && that.selectedRecord.doc_type!='pdf') {
              $(iframe).contents().find("head").append(that.cssMask);
            }

            var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

            if (printHeight < iframeDocument.body.offsetHeight) {
              frameHeight = iframeDocument.body.offsetHeight + 30;              
            } else {
              frameHeight = printHeight;
            }

            // if email is large, scale down so it will print on one page
            if (frameHeight > printHeight && frameHeight < 2000) {
              let ifHeight = printHeight;
              let scalePct = ((that.selectedRecord) && that.selectedRecord.doc_type!='pdf') ? ifHeight/frameHeight : 1;
                        
              if (frameHeight>=ifHeight) {
                  iframe.style.msTransform='scale('+scalePct+')';
                  iframe.style.msTransformOrigin='0% 0%';
                  iframe.style.webkitTransform='scale('+scalePct+')';
                  iframe.style.webkitTransformOrigin='0% 0%';
                  iframe.style.transform='scale('+scalePct+')';
                  iframe.style.transformOrigin='0% 0%';
              }

            }
            iframe.style.height = frameHeight + 'px'; 

            //previousPrintedPage = iframe.src;
          }

          function checkLoaded(){
            var doc = iframe.contentDocument || (iframe.contentWindow ? iframe.contentWindow.document : null);
            // We can tell if there is a dummy document installed because the dummy document
            // will have an URL that starts with "about:".  The real document will not have that URL
            if (doc && doc.URL.indexOf("about:") !== 0) {
              if ((doc.readyState === "complete" || doc.readyState === "interactive") && doc.body && doc.body.offsetHeight) {
                console.log("loaded: readyState = " + doc.readyState);
                formatPrintPane();
              } else if (timerCount >= 2000 && (doc.readyState === "complete" || doc.readyState === "interactive")) { // 2000 * 10 = 20 seconds to wait before giving up on doc.body being available
                console.log("Waited 20 seconds for content to load")
                formatPrintPane();
              } else {
                timerCount++
                timer = setTimeout(checkLoaded, 10);
              }
            } else {
              // still same old original document, so keep looking for content or new document
              timer = setTimeout(checkLoaded, 10);
            }
          }
          checkLoaded();

        }
      } else {
        iframe.src = "data:text/html;charset=utf-8," + "<html><body>Printing individual emails is not enabled with your account</body></html>";
        return false;
      }

    },
    async resendEmail(to,email) {
      this.$eventBus.$emit("showStatus",{
        msg:`Email queued for delivery to: <span class="font-semibold">${to}</span>`,
      });

      // send email
      let params = {
        email: to,
        locator: email.locator,
        subject: email.subject,
        email_record: email,
      };
      try {
        const response = await fetch("/api/v2/email/send", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        });
        let result = await response.json();
        if (!response.ok){
          if (response.status == 401){
            window.location.href = "/login";
          } else {
            let msg = `Could not send to ${to}. ${result.message}.<br/><i>Please confirm you are connected to the internet and try again.</i>`;
            this.$eventBus.$emit("showStatus",{
              msg: msg,
              isWarning: true,
            });
          }
          console.log(result);
        } else {
          //success
          this.showResendDifferent= false;
          this.differentEmailAddress = null;
        }
      } catch (err){
        let msg = `Could not send to ${to}. `+ err +`.<br/><i>Please confirm you are connected to the internet and try again.</i>`;
        this.$eventBus.$emit("showStatus",{
          msg: msg,
          isWarning: true,
        });
        console.log(err);
      }
      this.$store.commit("setResendEmailAddress",null);
      this.$store.commit("setResendChange",false);
      let props = {
        same_address:(to.toLowerCase()==email.email),
        sub_account_id: email.sub_account_id,
      }
      this.$store.dispatch("track",{name:"email_resend",props:props})
    },
  }
}